module.exports = __webpack_public_path__ + "static/media/multiply.e9e33301.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/multiply.svg
// module id = 1409
// module chunks = 0